import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Avatar,
  Box,
  Divider,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  Mail as MailIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface AdminHeaderProps {
  open: boolean;
  onDrawerToggle: () => void;
}

const drawerWidth = 280;

const AdminHeader: React.FC<AdminHeaderProps> = ({ open, onDrawerToggle }) => {
  const { t } = useTranslation();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: "#ffffff",
        color: "#111827",
        borderBottom: "1px solid #e5e7eb",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        width: open ? `calc(100% - ${drawerWidth}px)` : "100%",
        left: open ? `${drawerWidth}px` : 0,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        zIndex: 1100,
      }}
    >
      <Toolbar sx={{ minHeight: 80, px: 4 }}>
        {/* Left Section */}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 3, flexGrow: 1 }}
        >
          <IconButton
            onClick={onDrawerToggle}
            sx={{
              color: "#6b7280",
              background: "#f8fafc",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              transition: "all 0.2s ease",
              transform: open ? "rotate(0deg)" : "rotate(180deg)",
              "&:hover": {
                background: "#f3f4f6",
                borderColor: "#6366f1",
                color: "#6366f1",
                transform: open
                  ? "rotate(0deg) scale(1.1)"
                  : "rotate(180deg) scale(1.1)",
              },
            }}
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h5" fontWeight={700} color="#111827">
              {t("admin.header.dashboard")}
            </Typography>
            <Typography variant="body2" color="#6b7280" fontSize="14px">
              {t("admin.header.welcomeToAdminPanel")}
            </Typography>
          </Box>
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton
            sx={{
              color: "#6b7280",
              background: "#f8fafc",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              "&:hover": {
                background: "#f3f4f6",
                borderColor: "#6366f1",
                color: "#6366f1",
              },
            }}
          >
            <Badge badgeContent={3} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>

          <IconButton
            sx={{
              color: "#6b7280",
              background: "#f8fafc",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              "&:hover": {
                background: "#f3f4f6",
                borderColor: "#6366f1",
                color: "#6366f1",
              },
            }}
          >
            <Badge badgeContent={5} color="primary">
              <MailIcon />
            </Badge>
          </IconButton>

          <Divider orientation="vertical" flexItem sx={{ mx: 2, height: 30 }} />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 3,
              py: 1,
              px: 2,
              borderRadius: "8px",
              border: "1px solid #e5e7eb",
              background: "#f8fafc",
              cursor: "pointer",
              "&:hover": {
                background: "#f3f4f6",
                borderColor: "#6366f1",
              },
            }}
          >
            <Avatar
              sx={{
                width: 40,
                height: 40,
                background: "#6366f1",
                fontWeight: 700,
                fontSize: "14px",
              }}
            >
              A
            </Avatar>
            <Box>
              <Typography variant="body2" fontWeight={700} color="#111827">
                {t("admin.header.adminUser")}
              </Typography>
              <Typography variant="body2" color="#6b7280" fontSize="12px">
                admin@r11.com
              </Typography>
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AdminHeader;
